// extracted by mini-css-extract-plugin
export default {"pillContainer":"PillSwitcher_pillContainer__H0Eps","pill":"PillSwitcher_pill__NEZmT","active":"PillSwitcher_active__pN8FC"};